<template>
  <!-- 企业资讯 -->
  <div class="box">
    <!-- 头部 -->
    <div class="logoTop">
      <span><img src="../../assets/anluoyun.png" alt="" style="width:13%" /></span>
      <span @click="viewList()"><van-icon name="bars" /></span>
    </div>
    <van-popup
      v-model="tabShow"
      class="tabShow"
      position="right"
      :style="{ height: '100%' }"
    >
      <div style="margin:15px"> 
        <img src="../../assets/anluoyun.png" alt="" style="width:80%;margin:0 10%">
      </div>
      <ul>
        <li><router-link to="/anLuoYun">网站首页</router-link></li>
        <li>
          <router-link to="/anLuoYun/about">关于我们</router-link>
        </li>
        <li><router-link to="/anLuoYun/serve">企业项目</router-link></li>
        <li><router-link to="/anLuoYun/recruit">企业招聘</router-link></li>
        <li class="select"><router-link to="/anLuoYun/message">企业资讯</router-link></li>
        <li><router-link to="/anLuoYun/contact">联系我们</router-link></li>
      </ul>
    </van-popup>
    <!-- 标题 -->
    <div class="title">
      企业资讯
    </div>
    <!-- 内容 -->
    <article class="center">
      <div class="boxList">
        <div>安洛云涧西区精准帮扶平台上线</div>
        <div class="van-multi-ellipsis--l2">安洛云涧西区精准帮扶平台已正式上线，面向待帮扶居民与社区工作人员</div>
      </div>
      <div class="boxList">
        <div>安洛云涧西区精准帮扶平台上线</div>
        <div class="van-multi-ellipsis--l2">安洛云涧西区精准帮扶平台已正式上线，面向待帮扶居民与社区工作人员</div>
      </div>
      <div class="boxList">
        <div>安洛云涧西区精准帮扶平台上线</div>
        <div class="van-multi-ellipsis--l2">安洛云涧西区精准帮扶平台已正式上线，面向待帮扶居民与社区工作人员</div>
      </div>
      <div class="boxList">
        <div>安洛云涧西区精准帮扶平台上线</div>
        <div class="van-multi-ellipsis--l2">安洛云涧西区精准帮扶平台已正式上线，面向待帮扶居民与社区工作人员</div>
      </div>
      <div class="boxList">
        <div>安洛云涧西区精准帮扶平台上线</div>
        <div class="van-multi-ellipsis--l2">安洛云涧西区精准帮扶平台已正式上线，面向待帮扶居民与社区工作人员</div>
      </div>
      <div class="boxList">
        <div>安洛云涧西区精准帮扶平台上线</div>
        <div class="van-multi-ellipsis--l2">安洛云涧西区精准帮扶平台已正式上线，面向待帮扶居民与社区工作人员</div>
      </div>
    </article>
      <!-- 底部 -->
    <aside class="buttonVal">
      <div>电 话：18837992186</div>
      <div>地 址：洛阳市经济技术开发区长夏门街32号863创智广场1 幢2201</div>
      <div>版 权：河南安洛云信息科技有限公司</div>
      <div>备案号：豫ICP备17050318号-1</div>
    </aside>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabShow: false,
    };
  },
  methods: {
    // 顶部tab菜单显示
    viewList() {
      if (this.tabShow == true) {
        this.tabShow = false;
      } else {
        this.tabShow = true;
      }
    },
    pushTo(row) {},
  },
};
</script>
<style scoped>
.logoTop {
  z-index: 2;
  position: fixed;
  top: 0;
  width: 100%;
  height: 65px;
  background: #fff;
  box-shadow: 0px 1px 5px #ccc;
}
.logoTop span:nth-child(1) {
  position: absolute;
  left: 15px;
  top: 10px;
}
.logoTop span:nth-child(2) {
  position: absolute;
  right: 15px;
  top: 13px;
  font-size: 37px;
}
.tabShow {
  width: 130px;
}
.tabShow li {
  padding: 8px 0px;
  text-align: center;
  color: #000;
}
.tabShow a {
  color: #000;
}
.tabShow .select {
  background: #ccc;
}
.tabShow .select a {
  color: #0076f6;
}
.title {
  margin: 90px 15px 0 15px;
  font-size: 18px;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 2px solid #2196f3;
}
.center {
  position: relative;
  margin-top: 5px;
  height: 60%;
  overflow-y: scroll;
}
.buttonVal {
  position: absolute;
  bottom: 0px;
  padding: 8px 15px;
  background: #333333;
  font-size: 14px;
  color: #fff;
}
.buttonVal div {
  margin: 5px;
}
.child-view {
  height: 100%;
}
.boxList {
  font-size: 15px;
  line-height: 30px;
  padding: 8px 15px;
  border-bottom: 1px dashed #ccc;
}
.boxList div:nth-child(1){

}
.boxList div:nth-child(2){
  font-size: 12px;
}
</style>